import MainButton from '@/components/LayoutApp/FooterBar/MainButton'
import CallButton from '@/components/LayoutApp/FooterBar/CallButton'
import RouteButton from '@/components/LayoutApp/FooterBar/RouteButton'
import OrdersListButton from '@/components/LayoutApp/FooterBar/OrdersListButton'
import DeliverOrderButton from '@/components/Screens/CurrentOrderScreen/DeliverOrderButton'
import PostponedButton from '@/components/Screens/CurrentOrderScreen/PostponedButton'
import { useDeliveryAppContext } from '@/context/deliveryApp/DeliveryAppContext'
import { Transition } from '@headlessui/react'

const Footer = () => {
  const { showDeliverButton } = useDeliveryAppContext()

  return (
    <>
      {showDeliverButton && (
        <Transition
          className="fixed bottom-[72px] max-w-3xl flex items-center justify-between w-full mt-6 px-3"
          appear={true}
          show={showDeliverButton}
          enter="transition duration-100 ease-out"
          enterFrom="transform scale-95 opacity-0"
          enterTo="transform scale-100 opacity-100"
          leave="transition duration-75 ease-out"
          leaveFrom="transform scale-100 opacity-100"
          leaveTo="transform scale-95 opacity-0"
        >
          <section className="flex items-center justify-between w-full text-sm bg-transparent">
            <DeliverOrderButton />
            <PostponedButton />
          </section>
        </Transition>
      )}

      <footer className="dark:bg-black-darkMode border-gray-tertiary dark:border-gray-darkMode fixed bottom-0 flex flex-row items-center justify-around w-full p-1 bg-white border-t h-[56px] rounded-t-2xl ">
        <div className="flex flex-row items-center justify-around w-full max-w-3xl">
          <MainButton />
          <OrdersListButton />
          <RouteButton />
          <CallButton />
        </div>
      </footer>
    </>
  )
}

export default Footer
